<template>
<div>
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  
    <a class="navbar-brand" @click="jump('/')" style="cursor: pointer;"><strong>DCTECH CS课堂</strong></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" style="justify-content: end;">
      <ul class="navbar-nav">
        <!-- <li class="nav-item">
          <a class="nav-link" @click="jump('/')">首页 <span class="sr-only">(current)</span></a>
        </li> -->

        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
            课程列表
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" style="cursor: pointer;" @click="jump('/java')">Java课程</a>
            <a class="dropdown-item" style="cursor: pointer;" @click="jump('/cpp')">C++课程</a>
            <a class="dropdown-item" style="cursor: pointer;" @click="jump('/ap')">AP CSA课程</a>
            <a class="dropdown-item" style="cursor: pointer;" @click="jump('/algorithm')">数据结构与算法</a>
          </div>
        </li> -->

          <!-- <li class="nav-item">
            <a class="nav-link"  @click="jump('/faq')">常见问题</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  @click="jump('/online-coding')">在线编程器</a>
          </li> -->
          <!-- <li class="nav-item" v-if="$store.state.user != null">
            <a class="nav-link" href="/class">编程课堂</a>
          </li>
          <li class="nav-item" v-if="$store.state.user != null">
            <a class="nav-link" href="/exercise">练习系统</a>
          </li> -->

          <li class="nav-item" v-if="$route.params.classId != null">
            <a class="nav-link">Hello, {{ $route.params.classId }}</a>
          </li>
          <!-- <li class="nav-item" v-if="$store.state.user != null">
            <a class="nav-link" href="/exam">考试</a>
          </li> -->
          <!-- <li class="nav-item" v-if="$store.state.user == null">
            <a class="nav-link" @click="login">登录</a>
          </li>
          <li class="nav-item" v-else>
            <a class="nav-link"  @click="loginout">退出</a>
          </li> -->
     
      </ul>
    </div>

   
  </nav>

  <div class="modal fade" id="loginDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">登录系统</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div style="padding:20px 15px;position: relative;" >
                    <div style="margin-bottom: 10px;"><input class="form-control" placeholder="请输入手机号" v-model="mobile"/></div>
                    <div style="margin-bottom: 10px;"><input class="form-control" placeholder="请输入手机验证码" v-model="code"/></div>
                    <div style="position: absolute;right:25px;top:75px"><span style="color:#04b2c5;font-size:14px;margin-left:15px;cursor: pointer;" @click="sendCode()">{{loadingText}}</span></div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                <button type="button" class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5" @click="onLogin()">登录</button>
            </div>
            </div>
        </div>
    </div>
  </div>

</template>

<script>
import bus from '../utils/bus';

export default{
  data(){
    return{
      mobile:"",
      code:"",
      loadingText:"发送验证码"
    }
  },
  mounted(){
    let userStorage = window.localStorage.getItem("user");
    if(userStorage != null && userStorage != ""){
      let userObj = JSON.parse(userStorage);
      this.$store.commit('updateUser',userObj);
    }
  },
    methods:{
        jump(url){
            location.href=url;
        },
        startClass(){
            location.href="/class?target=17391200805&mobile="+this.$store.state.user.mobile;
        },
        login(){
          this.mobile = "";
          this.code = "";
          $('#loginDialog').modal('show');
        },
        onLogin(){
          let postInfo = {};
          postInfo.mobile = this.mobile;
          postInfo.captcha = this.code;

          // var result = {
          //   mobile:this.mobile
          // };
          // this.$store.commit('updateUser',result);
          // window.localStorage.setItem("user",JSON.stringify(result));
          // $('#loginDialog').modal('hide');
          // return;
          this.$http.post('https://programapi.dctechonline.cn/api/ap/login',postInfo).then(res=>{
              var result = res.data;
              if(result!=null){
                this.$store.commit('updateUser',result);
                window.localStorage.setItem("user",JSON.stringify(result));
                $('#loginDialog').modal('hide');
                bus.$emit('login');
              }
              else{
                alert(result.message);
              }
            })
        },
        loginout(){
          this.$store.commit('updateUser',null);
          window.localStorage.setItem("user","");
          bus.$emit('logout');
          location.href = '/';
        },
        sendCode(){
          if(this.mobile == ""){
            alert('请先输入手机号码');
          }
          else{
            const phoneRegex = /^1[3-9]\d{9}$/;
            const phoneNumber = this.mobile;
            if (!phoneRegex.test(phoneNumber)) {
              alert('手机号码格式错误');
              return;
            }

            if(this.loadingText != "发送验证码"){
              return;
            }

            var timer = 90;
            this.loadingText = timer +"秒后重发";
            var inter = setInterval(()=>{
              timer --;
              this.loadingText = timer +"秒后重发";
              

              if(timer == 0){
                this.loadingText = "发送验证码";
                clearInterval(inter);
              }
            },1000);
            
            this.$http.post('https://programapi.dctechonline.cn/api/ap/code',{
              mobile:this.mobile
            }).then(res=>{
              
              
            })
          }
        }
    }
}
</script>

<style lang="scss">
.navbar{
    position: fixed;
    top:0px;
    left:0px;
    width:100%;
    z-index:10;
    background:#04b2c5!important;
    color:white !important;

    a.nav-link{
    cursor: pointer;
    font-weight: bold;

    &:hover{
        color:#fbf8c9 !important;
    }
}
}

.navbar-light .navbar-brand{
    color:white !important;
}

.navbar-light .navbar-nav .nav-link {
    color:white
}
.nav-item{
  margin:0px 7px;
  font-size:15px;
}
</style>